import { Row, TableCell, TableRow, Text, Button, Icon } from "@amzn/meridian";
import editTokens from "@amzn/meridian-tokens/base/icon/edit";
import React, { useState } from "react";
import Textarea from "@amzn/meridian/textarea";
import { GroundTruthField, setFieldKnowledge } from "src/store/modelLifeCycleGroundTruthSlice";
import { useAppDispatch } from "src/store/store";

interface KnowledgeCellProps {
  groundTruthField: GroundTruthField;
  index: number;
}

const KnowledgeCell = ({ groundTruthField, index }: KnowledgeCellProps) => {
  const dispatch = useAppDispatch();
  const [isEditable, setIsEditable] = useState(false);
  const isEmpty = !groundTruthField.knowledge || groundTruthField.knowledge.trim() === "";

  return (
    <>
      <TableCell width={"1%"}></TableCell>
      <TableCell columnSpan={100}>
        <Row alignmentVertical="center" spacingInset="100" widths={["20%", "70%", "10%"]}>
          <Text type="b200">{`Reason for select ${groundTruthField.confirmedAnswer}:`}</Text>
          <Textarea
            placeholder="Enter the reason to improve model accuracy..."
            value={groundTruthField.knowledge || ""}
            onChange={(value) => {
              setIsEditable(true);
              dispatch(setFieldKnowledge({ fieldIndex: index, knowledge: value }));
            }}
            disabled={!isEmpty && !isEditable}
            rows={1}
          />
          <Button type="icon" size="small" onClick={() => setIsEditable(!isEditable)}>
            <Icon tokens={editTokens}>{isEditable ? "Disable editing" : "Enable editing"}</Icon>
          </Button>
        </Row>
      </TableCell>
    </>
  );
};

export default KnowledgeCell;
